export default __webpack_public_path__ + "static/media/lazada-logo.38f0c2a1.png";